<template>
  <div
    :class="[
      'article-head__wrapper',
      'article-head__wrapper--light',
      { 'article-head__wrapper--w-limited': isTempleArticle },
      { 'article-head__wrapper--festival': isFestivalYear },
    ]"
  >
    <!-- 刊頭圖片 -->
    <div
      :class="[
        'article-head__media',
        { 'location-home': cover_media.isHomePath },
      ]"
      :style="coverMediaStyle"
      v-if="cover_media.type === 'image'"
    >
      <!-- 首頁 -->
      <!-- 暫時隱藏 lazy-loading -->
      <img
        v-if="cover_media.isHomePath"
        :src="bannerPicture"
        class="lazyload"
        style="opacity: 1"
        alt="首頁圖片"
        title="首頁圖片"
      />
      <!-- <img
        v-if="cover_media.isHomePath"
        :data-reference="require('@/assets/images/banner.png')"
        class="lazyload"
        alt="首頁"
      />-->

      <!-- 其他頁面 -->
      <!-- 暫時隱藏 lazy-loading -->
      <img
        class="lazyload article-head__image"
        ref="coverImage"
        tabindex="0"
        :style="{ opacity: 1, maxHeight: coverImageMaxHeight }"
        v-else
        :src="cover_media.reference"
        :alt="cover_media.description || ''"
        :title="cover_media.description"
        @click="expandFullPhoto(cover_media)"
        @keyup.enter="expandFullPhoto(cover_media)"
      />

      <Lightbox
        :isPhotoExpanded="isPhotoExpanded"
        :isCurrentPhotoLoaded="isCurrentPhotoLoaded"
        :currentPhoto="currentPhoto"
        @update:currentPhotoLoaded="isCurrentPhotoLoaded = $event"
        @update:photoExpanded="isPhotoExpanded = $event"
        @update:currentPhoto="currentPhoto = $event"
      />

      <!-- <img
        class="lazyload"
        v-else
        :data-reference="
          cover_media.reference
            ? cover_media.reference
            : require('@/assets/images/banner.png')
        "
        :alt="cover_media.description ? cover_media.description : ''"
      />-->
      <noscript v-if="cover_media.isHomePath === 'undefined'">
        <img
          style="opacity: 1"
          :src="cover_media.reference"
          :alt="cover_media.description ? cover_media.description : ''"
          :title="cover_media.description"
        />
      </noscript>
    </div>
    <!-- 刊頭影片 -->
    <div class="article-head__media article-head__media--video" v-else>
      <iframe
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        :src="`https://www.youtube.com/embed/${cover_media.reference}`"
        :height="youtubeDynamicHeight"
        :width="windowWidth"
        :title="
          cover_media.description ? cover_media.description : '暫無影片描述'
        "
      ></iframe>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import homeDesktopBanner from '@/assets/images/banner.jpg';
import homeMobileBanner from '@/assets/images/banner_mobile@2x.jpg';
import Lightbox from '@/components/Lightbox';

export default {
  name: 'ArticleCoverMedia',
  props: {
    cover_media: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      isPhotoExpanded: false,
      currentPhoto: {},
      isCurrentPhotoLoaded: null,
    };
  },
  computed: {
    windowWidth() {
      return this.$store.getters.windowWidth;
    },
    youtubeDynamicHeight() {
      return this.windowWidth * 0.58;
    },
    isTempleArticle() {
      return this.$route.path.startsWith('/temple/');
    },
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
    bannerPicture() {
      return this.windowWidth > 1024 ? homeDesktopBanner : homeMobileBanner;
    },
    coverMediaStyle() {
      return this.cover_media.isHomePath
        ? {
          maxWidth: '100%',
        }
        : {
          maxWidth: '1024px',
        };
    },
    coverImageMaxHeight() {
      return this.windowWidth < 768
        ? `${this.windowWidth / 1.495}px`
        : `${this.windowWidth / 1.796}px`;
    },
  },
  methods: {
    expandFullPhoto(photo) {
      // 打開燈箱
      this.isPhotoExpanded = true;

      // 儲存必要資訊
      this.currentPhoto.image_url = photo.reference;
      this.currentPhoto.description = photo.description;
    },
  },
  components: {
    Lightbox,
  },
};
</script>

<style lang="scss" scoped>
.article-head {
  &__image {
    cursor: pointer;
    &:focus {
      outline: 2px $color-outline dotted;
    }
  }
  &__wrapper {
    position: relative;

    // for IE
    height: 250px;

    @include for-tablet {
      height: 308px;
    }
    @include for-desktop {
      height: 420px;
    }

    &--w-limited {
      max-width: 1024px;
      margin: auto;
    }

    &--light {
      height: auto;
      .article-head {
        &__media {
          position: relative;
          top: auto;
          left: auto;
          transform: none;

          @include for-tablet {
            max-width: 1024px;
            margin: 30px auto 0;
          }

          @include for-desktop {
            margin: 30px auto 20px;
          }

          @include for-tablet-horizontal {
            padding-left: 0;
            padding-right: 0;
          }

          img {
            max-height: 214px;
            object-position: center;

            @include for-tablet {
              max-height: 100%;
            }
            @include for-desktop {
              border-radius: 10px;
            }
          }

          &--video {
            padding: 0;
            @include for-tablet {
              /* padding: 15px 15px 0; */
            }

            @include for-tablet-horizontal {
              padding-left: 0;
              padding-right: 0;
            }

            > iframe {
              max-width: 100%;
              max-height: 100%;
              @include for-tablet {
                max-width: 1024px;
                max-height: 570px;
              }
              @include for-desktop {
                border-radius: 10px;
              }
            }
          }
        }

        &__title {
          position: relative;
          top: 100%;
          background: transparent;

          @include for-tablet {
            width: calc(100% - 30px);
            margin: 0 15px;
            box-shadow: none;
          }

          @include for-tablet-horizontal {
            width: 100%;
            max-width: 1024px;
            margin: auto;
          }

          > h2 {
            color: $color-light-text;
            font-family: $text-font-family;
            line-height: 1.5;
            font-size: 1.3125rem;
            letter-spacing: 1.71px;

            @include for-tablet {
              font-size: 1.75rem;
              margin-top: 20px;
            }
            @include for-desktop {
              letter-spacing: 1.71px;
            }
          }

          &::before {
            background: none;
          }
        }
      }
    }

    &--festival {
      .article-head {
        &__title {
          > h2 {
            margin-top: 15px;
          }

          &::after {
            background: url("../../assets/images/header/divider_festival.png");
            background-size: cover;
            width: 100%;
            height: 15px;
            bottom: -15px;
            top: 0;

            @include for-tablet {
              bottom: 61px;
              left: 0;
              border-bottom-left-radius: 10px;
              border-bottom-right-radius: 10px;
            }
          }
        }
      }
    }
  }

  &__media {
    font-size: 0; /* 取消 inline 的空白 */
    // for IE
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;

    img {
      max-height: 250px;
      min-height: 160px;
      opacity: 0;
      transition: opacity 600ms ease-in;
      // IE not working
      object-fit: cover;
      object-position: top;

      // for IE
      height: auto;
      width: 100%;

      @include for-tablet {
        max-height: 308px;
        min-height: 308px;
      }

      @include for-desktop {
        max-height: 420px;
        min-height: 420px;
      }
    }

    &--video {
      position: relative;
      z-index: getLayerIndex(media);
      padding: 3rem 0 4rem;
      text-align: center;

      @include for-desktop {
        padding-top: 5rem;
      }

      & > iframe {
        width: 100%;
        max-width: 560px;
        max-height: 326px;
      }
    }
  }
}

.location-home.article-head__media {
  margin: 18px 0 0;

  &::before {
    content: "";
    width: 100%;
    height: 150px;
    position: absolute;
    /* dark mode only */
    /* background: linear-gradient(180deg, transparent, black); */
    bottom: 0;
    left: 0;
  }
  img {
    opacity: 1;
    border-radius: 0 !important;
  }
}
</style>
